import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

const resolverOngId = (origem) => {
  const candidatos = [
    origem?.ongId,
    origem?.ong?.id,
    origem?.ong?.ongId,
    origem?.ong_id,
    origem?.idOng,
    origem?.id_ong,
    origem?.organizacaoId,
    origem?.organizacao?.id,
  ];

  const encontrado = candidatos.find((valor) => {
    if (valor === null || valor === undefined) return false;
    const texto = String(valor).trim().toLowerCase();
    // Garante que não aceite strings inúteis que o banco ou Java podem enviar
    return texto !== '' && texto !== 'null' && texto !== 'undefined' && texto !== '0';
  });

  return encontrado != null ? String(encontrado) : null;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem('petadote_user');
    if (savedUser) {
      const parsedUser = JSON.parse(savedUser);
      const normalizedUser = {
        ...parsedUser,
        ongId: resolverOngId(parsedUser)
      };
      setUser(normalizedUser);
    }
  }, []);

const login = (userData) => {
  const idCapturado = resolverOngId(userData);

  const normalizedData = {
    ...userData,
    ongId: idCapturado,
  };

  setUser(normalizedData);
  localStorage.setItem('petadote_user', JSON.stringify(normalizedData));

  console.log("Login realizado com sucesso! ONG vinculada:", idCapturado);
};

  const logout = () => {
    setUser(null);
    localStorage.removeItem('petadote_user');
  };

  // --- LÓGICA DE PERMISSÕES ATUALIZADA ---
const perfil = String(user?.perfil || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();
  
  const isAdmin = perfil === 'ADMIN';
  const isSupervisor = perfil === 'SUPERVISOR';
  const isVeterinario = perfil === 'VETERINARIO';
  const isCadastrador = perfil === 'CADASTRADOR';

  // Verifica se existe uma ONG vinculada (essencial para o prontuário)
  const possuiOng = user?.ongId !== null && user?.ongId !== undefined && String(user?.ongId).trim() !== '';

  // --- REGRAS DO PRONTUÁRIO ---
  
  // 1. Só vê o botão de prontuário se for Admin, Cadastrador, Veterinario ou Supervisor
  const podeVerProntuario = isAdmin || isCadastrador || isVeterinario || isSupervisor;

  // 2. Admin sempre edita; supervisor/vet somente com ONG (Cadastrador apenas visualiza)
  const podeEditarProntuario = isAdmin || (possuiOng && (isSupervisor || isVeterinario));

  // 3. Flag auxiliar para desabilitar botões de "Salvar" ou "Adicionar" dentro do prontuário
  const apenasLeituraProntuario = isCadastrador && !isAdmin;

  return (
    <AuthContext.Provider value={{ 
      user, 
      login, 
      logout, 
      isAdmin, 
      isSupervisor, 
      isVeterinario, 
      isCadastrador,
      possuiOng,
      podeVerProntuario,
      podeEditarProntuario,
      apenasLeituraProntuario,
      podeGerenciarAdocao: isAdmin || isSupervisor || isCadastrador,
      podeGerenciarUsuarios: isAdmin || isSupervisor,
      userOngId: user?.ongId || null,
      usuarioId: user?.id || null,
      userEmail: user?.email || user?.username || null // Fallback caso o campo venha como username
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);